import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useChartOptions(minDate, maxDate) {
  const { t } = useTranslation();

  return useMemo(() => {
    return {
      // disabled parsing for performance
      parsing: false,
      // rounded lines
      tension: 0.3,
      scales: {
        x: {
          type: 'time',
          min: minDate.valueOf(),
          max: maxDate.valueOf(),

          title: {
            display: true,
            text: t('Čas'),
          },

          ticks: {
            source: 'auto',
            // Disabled rotation for performance
            maxRotation: 0,
            autoSkip: true,
          },
          time: {
            displayFormats: {
              datetime: 'DD. MMM. YYYY, HH:mm:ss',
              millisecond: 'HH:mm:ss.SSS',
              second: 'HH:mm:ss',
              minute: 'HH:mm',
              hour: 'HH',
              day: 'MMM DD',
              week: 'll',
              month: 'MMM YYYY',
              quarter: '[Q]Q - YYYY',
              year: 'YYYY',
            },
          },
        },

        y: {
          title: {
            display: true,
            text: t('Hodnota'),
          },
        },
      },

      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },

      plugins: {
        decimation: {
          enabled: true,
          algorithm: 'lttb',
          samples: 750,
        },
        colors: {
          // fix for buggy color
          forceOverride: true,
        },
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxDate, minDate]);
}
